module.exports = "<router-outlet></router-outlet>\n<app-footer *ngIf=\"router.url !== '/diagnostico'\"></app-footer>"